import { sendMessage } from '../../../config/utils/message'
import { CORE_API_AKADEMIK } from '../../key/api'

// API GET METHOD

/**
 * Function UseApiJadwal, getJadwalDiajukan
 * @param {String} method 
 * @param {Arr} params => nim, semester, smtta, ta, kurikulum, kdjur, idjur 
 * @param {Arr} data 
 * @returns Object
 */

export const POST = 'POST'
export const GET = 'GET'

export async function UseApiJadwal(method, params, data) {
    try {
        const response = await CORE_API_AKADEMIK({
            method: method,
            url: 'pilihjadwal/tabelbawah',
            params: params,
            data: { check_list: data }
        })

        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

export async function getJadwalDiajukan(params) {
    try {
        const response = await CORE_API_AKADEMIK.get('pilihjadwal/tabel/atas/view', { params: params })
        return response
    }
    catch (err) {
        sendMessage(500)
    }
}

// API POST METHOD
export async function setUlangJadwal(data) {
    try {
        const admin = localStorage.getItem("nim");
        const response = await CORE_API_AKADEMIK.post('pilihjadwal/setulang', { check_list: data, admin  });
        return response;
    } catch (err) {
        sendMessage(500);
    }
}

export async function setBatalJadwal(data) {
    try {
        const admin = localStorage.getItem("nama");
        const response = await CORE_API_AKADEMIK.post('pilihjadwal/batalkan', { check_list: data, admin });
        return response;
    } catch (err) {
        sendMessage(500)
    }
}

export async function validasiButtonCetak() {
    try {
        const response = await CORE_API_AKADEMIK.get('validasi/button/cetak/kartu');
        return response;
    } catch (err) {
        sendMessage(500);
    }
}

export async function validasiEvaluasi(nim, ta, smtta, kurikulum) {
    try {
        const response = await CORE_API_AKADEMIK.get(
            `validasi/evaluasi/cetak/kartu?nim=${nim}&ta=${ta}&smtta=${smtta}&kurikulum=${kurikulum}`
        );
        return response;
    } catch (error) {
        console.error("Error during validasiEvaluasi:", error);
        throw error;
    }
}

export async function decisionCetak(nim) {
    try {
        const response = await CORE_API_AKADEMIK.get(
            `validasi/cetak/kartu?nim=${nim}`
        );
        return response;
    } catch (error) {
        console.error("Error during:", error);
        throw error;
    }
}


// API PUT METHOD